"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyStore = void 0;
var keystores_1 = require("@near-js/keystores");
Object.defineProperty(exports, "KeyStore", { enumerable: true, get: function () { return keystores_1.KeyStore; } });
